// Shared read-only detail row (label + value) for the admin detail views (Users, Persons).
// Renders inside a <dl className="fawkes-admin__fields">. Extracted to avoid the verbatim
// duplication that previously lived in both Users.tsx and Persons.tsx.
export function Detail({ label, value }: { label: string; value: string | null }) {
  return (
    <div className="fawkes-admin__field">
      <dt>{label}</dt>
      <dd>{value || "—"}</dd>
    </div>
  );
}
